// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"321c1e37","425":"bd0e8e85","510":"aeeb9b9d","532":"414d80e7","633":"322599ac","634":"11df2991","922":"08028263","937":"9a1760b1","972":"d6ee1a7e"}[chunkId] + ".chunk.js";
};